import { render, staticRenderFns } from "./SpaceDashboard.vue?vue&type=template&id=d0e67b3c&scoped=true&"
import script from "./SpaceDashboard.vue?vue&type=script&lang=js&"
export * from "./SpaceDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SpaceDashboard.vue?vue&type=style&index=0&id=d0e67b3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e67b3c",
  null
  
)

export default component.exports